import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import cet from '@/components/cet/cet'
import ielts from '@/components/ielts/ielts'
import studyabroad from '@/components/studyabroad/studyabroad'
import coursedetails from '@/components/coursedetails/coursedetails'
import mycenter from '@/components/mycenter/mycenter'
import livebroadcast from '@/components/livebroadcast/live'
import checkplatform from '@/components/checkPlatform/index'
Vue.use(Router)

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/cet/cet',
      name: 'cet',
      component: cet
    },
		{
		  path: '/studyabroad/studyabroad',
		  name: 'studyabroad',
		  component: studyabroad
		},
		{
		  path: '/ielts/ielts',
		  name: 'ielts',
		  component: ielts
		},
		{
		  path: '/coursedetails/coursedetails',
		  name: 'coursedetails',
		  component: coursedetails
		},
    {
      path: '/mycenter/mycenter',
      name: 'mycenter',
      component: mycenter
    },
    {
      path: '/livebroadcast/live',
      name: 'livebroadcast',
      component: livebroadcast
    },
    {
      path:'/checkplatform',
      name:'checkplatform',
      component:checkplatform
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js